/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

"use strict";

let appEnv;

const {
  WEALTHPRESS_BASE_URL = "http://wealthpress.wealthy.internal"
} = process.env;

const WEALTHPRESS_LOCAL_BASE_URL = "https://api.wealthydev.in/wealthpress-local";

switch (process.env.NEXT_PUBLIC_WEALTHY_ENV) {
  case "development":
    appEnv = {
      URL: "https://www.wealthydev.in",
      APP_URL: "https://app.wealthydev.in",
      TESSERACT_BASE_URL: "https://broking.wealthydev.in",
      BUILDWEALTH_APP_URL: "https://app.buildwealthdev.in",
      GATE_WEALTHY_API_URL: "https://api.wealthydev.in",
      GATE_WEALTHY_APIS_URL: "https://api.wealthydev.in",
      BUILDWEALTH_API_URL: "https://api.buildwealthdev.in",
      BUILDWEALTH_GRAPHQL_URL: "https://graph.buildwealthdev.in/graphql/",
      FIXED_DEPOSIT_API_BASE_URL: "https://api.wealthydev.in",
      INSURANCE_API_BASE_URL: "https://api.wealthyinsurancedev.in",
      GATE_WEALTHPRESS_API_URL: `${WEALTHPRESS_BASE_URL}/api/v0`,
      GATE_WEALTHY_ECS_API_URL: `${WEALTHPRESS_BASE_URL}`,
      GATE_EDITOR_API_URL: "https://api.wealthydev.in/wealthpress-editor-apis",
      GATE_PULSE_API_URL: "https://api.gragedev.in",
      MOBILE_WEB_URL: "https://m.wealthydev.in",
      LANDING_URL: "https://wealthydev.in",
      WEALTHPRESS_TOOLS_BASE_URL :  "https://api.wealthydev.in/wealthpress",

      GTM_ID: "GTM-WS54VKX",
      GA_TAG: "UA-67634408-6",
      EMAIL_ACCESS_REQUIRED: false,
      SEGMENT_KEY: "PTCvDN3MdGIqrmzOcTK37NdZT7PkB96N",
      APP_VERSION_INSURANCE: "insurance-web",
      APP_VERSION_FIXED_DEPOSIT: "fixeddeposit-web",
      TAXY_INTERNAL_API_URL: "http://api.wealthy.com",
      COOKIE_DOMAIN: ".wealthydev.in",
      WEALTHY_TALKZ_EVENT_ID: "event_Krm873e5mk652TMsPvBSGF",
      REGISTER_FOR_WEALTHY_EVENT_SCHEDULE_ID: "event_schedule_9MCBLo4myMzPLhVwa53Wui",
      REGISTER_FOR_100_CRORE_SCHEDULE_ID: "event_schedule_9MCBLo4myMzPLhVwa53Wui",
      REGISTER_FOR_GET_WEALTHY_SCHEDULE_ID: "event_SnJYsRXkKVLDy7BcrPsxoc",
      SCHEDULE_ID_FOR_FUTURE_EVENTS: "event_schedule_YVCk9ivSG6QSngKKUqSzsb",
      REGISTER_LIVE_URL: "https://event.wealthydev.in",
      RECAPTCHA_SITEKEY: "6LfRl6IUAAAAAPiKd9sE2o71nu500AR_keUuh5ZE",
      IS_PRODUCTION: false,
      CLIENT_ID: "d485a5b13fdf631113267e812284c71d",
      ADVISOR_CLIENT_ID: "68254df4b64bff1ce4ea18d81a437b3c",
      AUTH_API_URL: "https://api.wealthydev.in/wealthyauth/dashboard/api/v1",
      FURY_RECAPTCHA_SITE_KEY: "6LeYo0kaAAAAAPbeS5UUq8f3EvJ_8L2JNlGzpFDX",
      TINYMCE_KEY: "200mvypcn58s8utvnpo2hsbzps7204di9pq3nxld5bd9j74m",
      RZP_KEY: "rzp_test_n9Cp5njaben9BP",
      ONBOARDING_QNA_TYPE: "onboarding_v2" // old version :- onboarding
    };
    break;
  case "production":
    appEnv = {
      URL: "https://www.wealthy.in",
      APP_URL: "https://app.wealthy.in",
      TESSERACT_BASE_URL: "https://broking.wealthy.in",
      BUILDWEALTH_APP_URL: "https://app.buildwealth.in",
      BUILDWEALTH_API_URL: "https://api.buildwealth.in",
      BUILDWEALTH_GRAPHQL_URL: "https://graph.buildwealth.in/graphql/",
      GATE_WEALTHY_API_URL: "https://api.wealthy.in",
      GATE_WEALTHY_APIS_URL: "https://api.wealthy.in",
      WEALTHPRESS_TOOLS_BASE_URL: "https://api.wealthy.in/wealthpress",
      // GATE_WEALTHPRESS_API_URL: "http://wealthpress.wealthy.internal/api/v0",
      GATE_WEALTHPRESS_API_URL: `${WEALTHPRESS_BASE_URL}/api/v0`,
      GATE_WEALTHY_ECS_API_URL: `${WEALTHPRESS_BASE_URL}`,
      // GATE_WEALTHY_ECS_API_URL: "http://wealthpress.wealthy.internal",
      FIXED_DEPOSIT_API_BASE_URL: "https://api.wealthydev.in",
      INSURANCE_API_BASE_URL: "https://api.wealthyinsurance.in",
      GATE_EDITOR_API_URL: "https://api.wealthy.in/wealthpress-editor-apis",
      GATE_PULSE_API_URL: "https://api.grage.in",
      MOBILE_WEB_URL: "https://m.wealthy.in",
      LANDING_URL: "https://wealthy.in",
      GTM_ID: "GTM-PCSFTF5",
      GA_TAG: "UA-67634408-1",
      EMAIL_ACCESS_REQUIRED: true,
      SEGMENT_KEY: "p9SmEBYsM0wWZh7DCEAE2zUXEzz8mdgq",
      APP_VERSION_INSURANCE: "insurance-web",
      APP_VERSION_FIXED_DEPOSIT: "fixeddeposit-web",
      TAXY_INTERNAL_API_URL: "http://api.wealthy.com",
      COOKIE_DOMAIN: ".wealthy.in",
      WEALTHY_TALKZ_EVENT_ID: "event_6u5szBgDuJoeF9gBhGBH4G",
      REGISTER_FOR_WEALTHY_EVENT_SCHEDULE_ID: "event_fzvdpVWzfeNmv5RZiZmmAF",
      REGISTER_FOR_WEALTHY_WORKSHOP_SCHEDULE_ID: "event_schedule_58LiKGNV4ULVkqvSrxYiik",
      REGISTER_FOR_100_CRORE_SCHEDULE_ID: "event_NeJ9WEGAfZSq5JdtfupNNs",
      REGISTER_FOR_GET_WEALTHY_SCHEDULE_ID: "event_hoCqbjerVTUDxE622ByJft",
      SCHEDULE_ID_FOR_FUTURE_EVENTS: "event_schedule_bw2kswY7uhbhNPFSWmTaLC",
      REGISTER_LIVE_URL: "https://event.wealthy.in",
      RECAPTCHA_SITEKEY: "6LcexaIUAAAAAOV6Su0PwphnK0RDaDjpqjpzlH7a",
      IS_PRODUCTION: true,
      CLIENT_ID: "8917887a0139096bdc5223a23393ebd9",
      ADVISOR_CLIENT_ID: "5192f2e175d57149e3b5bd22b4ade70f",
      AUTH_API_URL: "https://api.wealthy.in/wealthyauth/dashboard/api/v1",
      FURY_RECAPTCHA_SITE_KEY: "6LeFgaIaAAAAAKNwsWEJXe_iDgplaDwBRMU3_wlR",
      TINYMCE_KEY: "6eymnmonmwc8y538uluy7is0wqdttnnj3ejquk2lwx3rrngo",
      RZP_KEY: "rzp_live_x0UWhoSAzsvhIX",
      ONBOARDING_QNA_TYPE: "onboarding_v2" // old version :- onboarding
    };
    break;
  default:
    appEnv = {
      URL: "https://www.wealthydev.in",
      APP_URL: "https://app.wealthydev.in",
      TESSERACT_BASE_URL: "https://broking.wealthydev.in",
      BUILDWEALTH_APP_URL: "https://app.buildwealthdev.in",
      GATE_WEALTHY_API_URL: "https://api.wealthydev.in",
      GATE_WEALTHY_APIS_URL: "https://api.wealthydev.in",
      BUILDWEALTH_API_URL: "https://api.buildwealthdev.in",
      BUILDWEALTH_GRAPHQL_URL: "https://graph.buildwealthdev.in/graphql/",
      GATE_WEALTHPRESS_API_URL: `${WEALTHPRESS_LOCAL_BASE_URL}/api/v0`,
      GATE_WEALTHY_ECS_API_URL: `${WEALTHPRESS_LOCAL_BASE_URL}`,
      FIXED_DEPOSIT_API_BASE_URL: "https://api.wealthydev.in",
      INSURANCE_API_BASE_URL: "https://api.wealthyinsurancedev.in",
      GATE_EDITOR_API_URL: "https://api.wealthydev.in/wealthpress-editor-apis",
      BROKING_COMPLIANCE_CDN_URL: "https://i.wlycdn.com/broking-compliance",
      GATE_PULSE_API_URL: "https://api.gragedev.in",
      MOBILE_WEB_URL: "https://m.wealthydev.in",
      LANDING_URL: "https://wealthydev.in",
      GTM_ID: "GTM-WS54VKX",
      GA_TAG: "UA-67634408-6",
      EMAIL_ACCESS_REQUIRED: false,
      SEGMENT_KEY: "PTCvDN3MdGIqrmzOcTK37NdZT7PkB96N",
      APP_VERSION_INSURANCE: "insurance-local",
      APP_VERSION_FIXED_DEPOSIT: "fixeddeposit-local",
      TAXY_INTERNAL_API_URL: "http://api.wealthy.com",
      WEALTHY_TALKZ_EVENT_ID: "event_6u5szBgDuJoeF9gBhGBH4G",
      REGISTER_FOR_WEALTHY_EVENT_SCHEDULE_ID: "event_fzvdpVWzfeNmv5RZiZmmAF",
      REGISTER_FOR_WEALTHY_WORKSHOP_SCHEDULE_ID: "event_schedule_58LiKGNV4ULVkqvSrxYiik",
      REGISTER_FOR_100_CRORE_SCHEDULE_ID: "event_ZPDmsx7acTf8a5fu9v9sop",
      REGISTER_FOR_GET_WEALTHY_SCHEDULE_ID: "event_TRrmi3XAYR5rqZ2kQ8JRs7",
      SCHEDULE_ID_FOR_FUTURE_EVENTS: "event_schedule_YVCk9ivSG6QSngKKUqSzsb",
      REGISTER_LIVE_URL: "https://event.wealthydev.in",
      COOKIE_DOMAIN: ".wealthydev.in",
      IS_PRODUCTION: false,
      CLIENT_ID: "d485a5b13fdf631113267e812284c71d",
      RECAPTCHA_SITEKEY: "6LfRl6IUAAAAAPiKd9sE2o71nu500AR_keUuh5ZE",
      ADVISOR_CLIENT_ID: "68254df4b64bff1ce4ea18d81a437b3c",
      AUTH_API_URL: "https://api.wealthydev.in/wealthyauth/dashboard/api/v1",
      FURY_RECAPTCHA_SITE_KEY: "6LeYo0kaAAAAAPbeS5UUq8f3EvJ_8L2JNlGzpFDX",
      TINYMCE_KEY: "6eymnmonmwc8y538uluy7is0wqdttnnj3ejquk2lwx3rrngo",
      RZP_KEY: "rzp_test_n9Cp5njaben9BP",
      ONBOARDING_QNA_TYPE: "onboarding_v2", // old version :- onboarding
      WEALTHPRESS_TOOLS_BASE_URL: "https://api.wealthydev.in/wealthpress",
    };
}


appEnv = {
  ...appEnv,

  FUNDS_API: "https://fundsapi.wealthy.in/market/v0",
  HOMEPAGE_CDN_URL: "https://i.wlycdn.com/wealthy-home-page",
  CDN_URL: "https://i.wlycdn.com",
  BROKING_COMPLIANCE_CDN_URL: "https://i.wlycdn.com/broking-compliance",
  PARTNERS_CDN_URL: "https://i.wlycdn.com/wealth-managers",
  GREY_MATTER_CDN_URL: "https://i.wlycdn.com/insights-new-release/articles",
  MERA_BUSINESS_CDN_URL: "https://i.wlycdn.com/mera-business",
  WEALTHY_FONT: "https://i.wlycdn.com/wealthy-fonts",
  BROKING_CDN_URL: "https://i.wlycdn.com/broking",
  AMC_LOGOS_NEW_CDN_URL: "https://i.wlycdn.com/amc-logos-new",

  FACEBOOK_SHARE_LINK: "https://www.facebook.com/sharer/sharer.php?u",
  TWITTER_SHARE_LINK: "https://twitter.com/intent/tweet?url",
  LINKEDIN_SHARE_LINK: "https://www.linkedin.com/sharing/share-offsite/?url",
  WHATSAPP_SHARE_LINK: "https://api.whatsapp.com/send",

  LINKEDIN_URL: "https://www.linkedin.com/in",
  TWITTER_URL: "https://www.twitter.com",

  SUBSCRIBE_SLUG: "money-order",
  SUBSCRIBE_CONFIRM_SLUG: "money-order-follow-up",
  ADVISOR_BASIC_SLUG: "wealth-manager-invite",
  ADVISOR_OPTIONAL_SLUG: "wealth-manager-follow-up",

  CALENDLY_URL: "https://calendly.com",
  PLACEHOLDER_IMAGE: "https://dummyimage.com/300x300/cccccc/cccccc",
  GOOGLE_FORMS_LINK: "https://docs.google.com/forms/d/e/1FAIpQLSfcawAESVam44m8SARUlJORX5t5tja4jnvz9vu0Cbf30U_uow/viewform?usp=sf_link",

  APP_DOWNLOAD_ONE_LINK: "http://onelink.to/getwealthy",
  PARTNER_APP_DEEP_LINK: "https://mylinks.wealthy.in/hJxA/fp36uh7c",
  PARTNER_APP_ONE_LINK: "https://wealthy.onelink.me/hJxA/1810fd23",
  PARTNER_APP_BLOG_ONE_LINK: "https://wealthy-partner.onelink.me/EvKf/9exlshqz",
  PARTNER_APP_DOWNLOAD_LINK: "https://wlty.page.link/TYpage",
  PLAY_STORE_DOWNLOAD_LINK: "https://play.google.com/store/apps/details?id=in.wealthy.android.wealthy",
  APP_STORE_DOWNLOAD_LINK: "https://itunes.apple.com/in/app/wealthy/id1222950243?mt=8",
  APPLE_STORE_DOWNLOAD_LINK: "https://apps.apple.com/in/app/wealthy-partner-sell-earn/id1585943279",
  RECAPTCHA_TOKEN_URL: "https://www.google.com/recaptcha/api.js?render=6LeYF64UAAAAAGk7lmH3au4gf-Zd8SUmkOyGKhm4",
  PARTNER_APP_NEW_PLAYSTORE_LINK: "https://play.google.com/store/apps/details?id=in.wealthy.android.advisor",
  PARTNER_APP_NEW_APPSTORE_LINK: "https://apps.apple.com/in/app/wealthy-partner-mfds-ifas/id1585943279",

  WEALTHY_FACEBOOK_LINK: "https://www.facebook.com/WealthyIN/",
  WEALTHY_TWITTER_LINK: "https://twitter.com/Wealthy_India",
  WEALTHY_INSTAGRAM_LINK: "https://www.instagram.com/wealthy_in/",
  WEALTHY_LINKEDIN_LINK: "https://www.linkedin.com/company/wealthy-in/",
  WEALTHY_YOUTUBE_LINK: "https://www.youtube.com/channel/UC9l9bEJdh4amzSVExsGsm3g",

  RECAPTCHA_TOKEN: "6LeYF64UAAAAAGk7lmH3au4gf-Zd8SUmkOyGKhm4",
  EVENT_RECAPTCHA: "6LeSqasfAAAAAPs1_HJDfhprNHwVPtZcBb3A4Xdx",
  // FROALA_KEY: "2J1B10dC4F6F6G5D4B3cwdcopmD-8D3agvC2B1F1F1B4E4H4B1A8C6==",
  FROALA_KEY: "iTB2xB5B1B1E4E2A1wH-8hocdykD1B-8H-8jC10D7D5B4B2B3D3E2A2A5==",
  SUBSCRIBER_DECRYPT_SECRET_KEY: "subscriber-list",

  WEALTHY_GOOGLE_MAP_LINK: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.70521990106!2d77.646303!3d12.912458!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xaa04154aecf2a5c2!2sWealthy.in+%7C+Build+Wealth+Technologies+Private+Limited!5e0!3m2!1sen!2sin!4v1519023088940",
  // WEALTHY_FRESHSALES_FORM: "https://wealthyin.freshsales.io/web_forms/37f0539d527aa1a6dbaf4e89cb74d817f235ee3d681751637d75ea5ae1b8e12e/form.js",
  WEALTHY_FRESHSALES_FORM: "https://wealthyin.freshsales.io/web_forms/cb03894e2b94bd75c02c8215daf767b38106624a1a1028e470e2892a8c5bee45/form.js",
  WEALTHY_EVENTS_GOOGLE_CALENDAR_URL: "https://calendar.google.com/event?action=TEMPLATE&tmeid=MWkwcXFtNjdkZXFqcHAycGdtdXNwc2s0MjQgY19pNHFiMjZobW9ra3M5YWZtaDk4OThsZHJlY0Bn&tmsrc=c_i4qb26hmokks9afmh9898ldrec%40group.calendar.google.com",
  WEALTHY_PARTNERS_APP_LINK: "https://play.google.com/store/apps/details?id=in.wealthy.android.advisor&referrer=utm_source%3Dorganic%26utm_medium%3Dlanding_page%26utm_term%3Dget_the_app%26utm_campaign%3Dpartner_app_install",
  WEALTHY_PARTNERS_APP_LINK_WITHOUT_UTM: "https://play.google.com/store/apps/details?id=in.wealthy.android.advisor",
  PARNTER_APP_DEEPLINK: "https://applinks.buildwealth.in"
};

module.exports = appEnv;
